$(document).ready(function () {
  if($('.dropdown_column__menu.active').attr('data-menu') != undefined){
    var menu1=$('.dropdown_column__menu.active').attr('data-menu');
    $('.sub-megamenu[data-attr="'+menu1+'"]').show();
  }
  $(".product_gallery_nav .gallery-cell.product-gallery__thumbnail:first").trigger("click");
  $(".swatch-element").click(function () {
    if ($(window).width() < 799) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  });

  $('a[href^="#news"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));
    if (target.length) {
      event.preventDefault();
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: target.offset().top - 150,
          },
          600
        );
    }
  });
  $(document).on("click", ".cart-main-close", function () {
    $(".cart-container").removeClass("active_link");
    $("body").removeClass("open-cart");
  });
  $(document).on("click", ".customer_note .global-button", function (e) {
    e.preventDefault();
    var values = [];
    $(".dog_age").each(function () {
      var dogAgeVal = $.trim($(this).val());
      var dogNameVAl = $.trim($(this).siblings(".dog_name").val());
      if (dogAgeVal != "" || dogNameVAl != "") {
        values.push(dogNameVAl + "|" + dogAgeVal);
      }
    });

    $(".customer_noteInput").attr("value", "");
    if (values != "" && values != undefined) {
      $(".customer_noteInput").val(values);
      $(".customer_noteInput").removeAttr("disabled");
    }

    // console.log(values);
    $("#create_customer").submit();
  });
  var datePickerOptions = {
    changeMonth: true,
    changeYear: true,
    dateFormat: "dd/mm/yy",
    dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
  };
  $(".dog_age").datepicker(datePickerOptions);
  $("#extra-dog").click(function () {
    $(".dog_age").removeClass("hasDatepicker");
  });
  $("form").on("focus", "#extra-dog-details-jtpl .dog_age", function () {
    $(this).datepicker(datePickerOptions);
  });

  $(document).on(
    "keyup",
    ".main-outer-jtpl-sct .jtpl_modal input",
    function () {
      $(".main-outer-jtpl-sct .jtpl_modal .err_msg").hide();
    }
  );
  /* metafield-swatches js start*/
  //changefunjavascript//
  function eventFire(el, etype) {
    if (el.fireEvent) {
      el.fireEvent("on" + etype);
    } else {
      var evObj = document.createEvent("Events");
      evObj.initEvent(etype, true, false);
      console.log(evObj);
      el.dispatchEvent(evObj);
    }
  }
  // $('.swatch_options .variant_swatches').change(function(){
  // var variant_val = $(this).attr('value');
  //     $('.main-selector .main-switcher option').attr('selected',false);
  //     $('.main-selector .main-switcher option[data-name="'+variant_val+'"]').attr('selected','selected');
  //     eventFire(document.querySelector('.main-selector .main-switcher'), 'change');
  // });
  /* metafield-swatches js end*/

  /* megamenu js start*/
  $(".mega-menu.menu.dropdown_content .dropdown_column__menu").hover(
    function () {
      $(".mega-menu.menu.dropdown_content .dropdown_column__menu").removeClass(
        "active"
      );
      $(this).addClass("active");
      if (!$(this).hasClass("all-option")) {
        var secName = $(this).attr("data-menu");
        $(".sub-megamenu").hide();
        $('.sub-megamenu[data-attr="' + secName + '"]').show();
      }
    }
  );
  $(".back-main a").click(function () {
    $(this).parents(".mobile-mega-menu").addClass("hide-main");
    //$(this).parents('.mobile-mega-menu').find('.dropdown_title').addClass('hide-main');
  });
  $(".mobile-mega-menu .mobile-sub-list .mobile-arrow").click(function (e) {
    e.preventDefault();
    $(".mobile-mega-menu .mobile-sub-list").removeClass("is-active");
    $(this).parents(".mobile-mega-menu .mobile-sub-list").addClass("is-active");
    var secName = $(this)
      .parents(".mobile-mega-menu .mobile-sub-list")
      .attr("data-menu");
    //$(this).parents('.mobile-mega-menu').find('.mobile-sub-menu-list').hide();
    $(".sub-megamenu").removeClass("show-sub");

    $('.sub-megamenu[data-attr="' + secName + '"]').addClass("show-sub");
  });
  $(".mobileback").click(function () {
    $(this).parents(".sub-megamenu").removeClass("show-sub");
    $(this)
      .parents(".mobile-mega-menu")
      .find(".mobile-sub-list")
      .removeClass("is-active");
  });

  // $(".trial.sub-megamenu .subtitle-1-mobileback").click(function() {
  // $(this).parents(".trial.sub-megamenu").removeClass('show-sub');
  //     $(".dropdown_column").show();
  // });
  // $(".freshfood.sub-megamenu .subtitle-1-mobileback").click(function() {
  // $(this).parents(".freshfood.sub-megamenu").removeClass('show-sub');
  //     $(".dropdown_column").show();
  // });
  // $(".special.sub-megamenu .subtitle-1-mobileback").click(function() {
  // $(this).parents(".special.sub-megamenu").removeClass('show-sub');
  //     $(".dropdown_column").show();
  // });

  $(".parent-link--true").on("click", function () {
    $(this)
      .parents(".sublink")
      .find(".mobile-mega-menu")
      .toggleClass("hide-main");
  });

  /* megamenu js end*/

  // Flickity.prototype._createResizeClass = function() {
  //   this.element.classList.add('flickity-resize');
  // };

  // Flickity.createMethods.push('_createResizeClass');
  // var resize = Flickity.prototype.resize;
  // Flickity.prototype.resize = function() {

  //   this.element.classList.remove('flickity-resize');
  //   resize.call( this );
  //   this.element.classList.add('flickity-resize');
  // };

  /* readmore-content  js start*/
  $(".readmore_btn").click(function () {
    $(".readmore_content").show();
    $(".readmore_btn").hide();
    $(".description_main").hide();
  });
  $(".readless_btn").click(function () {
    $(".description_main").show();
    $(".readmore_content").hide();
    $(".readmore_btn").show();
  });
  /* readmore-content  js end*/

  /* header-scroll js start*/
  var lastScroll = 0;
  $(window).scroll(function () {
    setTimeout(function () {
      //gives 100ms to finish scrolling before doing a check
      var scroll = $(window).scrollTop();
      if (scroll > 80) {
        $("#header").addClass("fixed-sct");
      } else {
        $("#header").removeClass("fixed-sct");
      }
    }, 50);
  });

  /* header-scroll js end*/

  /* mobile-seach js start*/
  $(".mobile_search").click(function () {
    $(".show_seartch").slideDown();
    $(body).addClass("show-search");
  });
  $(".close_search").click(function () {
    $(".show_seartch").slideUp();
    $(body).removeClass("show-search");
  });
  /* mobile-seach js end*/
  /** PDP subcription box **/
  if ($(".psection.hasSubscription").length > 0) {
    var interval = setInterval(function () {
      if (
        $(".shopify-product-form .sls-purchase-options-container").length > 0
      ) {
        $(".shopify-product-form .sealsubs-target-element").addClass(
          "active-ed"
        );
        clearInterval(interval);
      }
    }, 500);
  }

  $(document).on(
    "click",
    ".sls-purchase-options-container .sls-option-container.seal-table:last-child",
    function () {
      $(this)
        .parents(
          ".sealsubs-target-element:not(.sealsubs-target-element.sealsubs-full)"
        )
        .addClass("active-ed");
    }
  );

  $(document).on(
    "click",
    ".sls-purchase-options-container .sls-option-container.seal-table:nth-child(2)",
    function () {
      $(this)
        .parents(
          ".sealsubs-target-element:not(.sealsubs-target-element.sealsubs-full)"
        )
        .removeClass("active-ed");
    }
  );
  $(document).on(
    "change",
    ".sls-purchase-options-container select.sls-select",
    function () {
      setTimeout(function () {
        if ($(".sls-selling-plan-description-content").text().length == 0) {
          $(".sls-selling-plan-description-content").hide();
        } else {
          $(".sls-selling-plan-description-content").show();
        }
      }, 500);
    }
  );
  $(document).on("click", ".close-widget", function () {
    $(this).parents(".sls-selling-plan-description-content").hide();
  });

  /** PDP subcription box END HERE **/

  /** ingredient-tab-js start **/

  $("ul.tabs.clearfix li:first-child a").trigger("click");

  $("ul.tabs").each(function () {
    var active,
      content,
      links = $(this).find("a");
    active = links.first().addClass("active");
    content = $(active.attr("href"));
    links.not(":first").each(function () {
      $($(this).attr("href")).hide();
    });

    $(this)
      .find("a")
      .click(function (e) {
        active.removeClass("active");
        content.hide();
        active = $(this);
        content = $($(this).attr("href"));
        active.addClass("active");
        content.show();
        return false;
      });
  });

  /** ingredient-tab-js end **/
  /** Option Title Append PDP Start **/
  $(".select.main-selector label.custom_lable").insertBefore(
    ".single-option-selector"
  );
  /** Option Title Append PDP End **/

  /** calculator popup start **/
  $(".popupshow").click(function () {
    $("#popup1").addClass("intro");
    $(".overlay").css("display", "block");
  });
  $(".close").click(function () {
    $("#popup1").remove("intro");
    $(".overlay").css("display", "none");
  });
  $("#popup1").click(function () {
    $(".overlay").css("display", "none");
  });
  /** calculator popup  End **/
  /** pdp variant price start**/
  var variant_price = $(".product-block--price").html();
  var mb_var_price = $(".top-price-cstm").html(variant_price);
  $(".main-selector .selector-wrapper").click(function () {
    var variant_price = $(".product-block--price").html();
    var mb_var_price = $(".top-price-cstm").html(variant_price);
  });
  /** pdp variant price end **/
});
// $(document).on('click',".cart-container",function() {
// var custom_height_get = $(".active_link .cart_content").outerHeight();
// var custom_height_get2 = $(".active_link .cart_content .cart-discount-list").outerHeight();
// var final_height_get = custom_height_get - custom_height_get2 - 100;
// $(".active_link.cart-container .cart_content ul.cart_items.js-cart_items").height(final_height_get);
// });

$(window).on("load scroll resize click", function () {
  var windowHeight = $(window).height();
  var annBar = $("header ").height();

  var ttlWindowheight = windowHeight - annBar;
  var ttlWindowheightmain = ttlWindowheight - 10;

  $(".cart_content").css("min-height", ttlWindowheightmain);
  $(".cart_content").css("max-height", ttlWindowheightmain);
  $(".cart_content").css("height", ttlWindowheightmain);

  // cart sub section
});

/* gallerysection js start*/
$(window).on("load scroll resize", function () {
  //    var maxHeight=0;
  //   $('.testimonial-block .subtitle').each(function(){
  //    var thisH = $(this).innerHeight();
  //     //console.log(thisH);
  //    if (thisH > maxHeight) { maxHeight = thisH; }
  // });
  //   $('.testimonial-block .subtitle').height(maxHeight);

  var hhih = $(
    ".gallery-section.gallery-classic .gallery-image-wrapper img"
  ).height();
  var hghg = $(
    ".gallery-sct-jtpl-new .gallery-image-wrapper.one-half:nth-child(6) .image-element__wrap img"
  ).height();
  $(
    ".gallery-sct-jtpl-new .gallery-image-wrapper.one-half:nth-child(3) .image-element__wrap img"
  ).css("height", hhih);
  $(
    ".gallery-sct-jtpl-new .gallery-image-wrapper.one-half:nth-child(5) .image-element__wrap img"
  ).css("height", hghg);

  // background-color sct
  if ($(".background-clr").length > 0) {
    var imgHeight = $(".fresh-feed-jtpl-sct .image-element__wrap img").height();
    var headHeight = $(".fresh-feed-jtpl-sct .one-whole.column").height();
    var ttlHeight = imgHeight + headHeight + 2;
    $(".fresh-feed-jtpl-sct .background-clr").css("height", ttlHeight);
  }

  // height of megamenu
  var mainBody = $(window).height();
  var mainBanner = $("header#header .promo-banner").height();
  var mainBar = $("header#header .top-bar").height();
  var headerTotal = mainBanner + mainBar;
  var totalmHeight = mainBody - headerTotal;
  $(".mobile-menu-container, ul.mobile-mega-menu").css("height", totalmHeight);

  var ttlmHeight = mainBody - headerTotal - 40;
  $("ul.mobile-mega-menu").css("height", ttlmHeight);
});
// $(window).on("resize",function(){
// setTimeout(function() {
//    var custom_height_get = $(".active_link .cart_content").outerHeight();
// var custom_height_get2 = $(".active_link .cart_content .cart-discount-list").outerHeight();
// var final_height_get = custom_height_get - custom_height_get2 - 100;
// $(".active_link.cart-container .cart_content ul.cart_items.js-cart_items").height(final_height_get);
// },500);

// });
/* gallerysection js end*/
/*collection all start */
$(document).mouseup(function (e) {
  if ($(e.target).closest(".jtpl-filter-sct-inner").length === 0) {
    $(".tag_filter").hide();
  }
});
$(".tag_filter").on("click", function () {
  $(".cancel").css("display", "block");
});
$(document).on("click", ".cancel", function () {
  $('.tag_filter li[data-handle="all-products"]').trigger("click");
});
/*collection all end*/

/*signup start*/
$("#extra-dog").on("click", function () {
  var form_div = $("#dog-detail-jtpl").html();
  $("#extra-dog-details-jtpl").append(
    "<div class='extra-dog-details-jtpl-class'>" + form_div + "</div>"
  );
  setTimeout(function () {
    var main_len = $("div#extra-dog-details-jtpl .dog_name").length;
    $("div#extra-dog-details-jtpl .dog_name").each(function (index) {
      var index_get = index + 1;
      var data_name = $(this).attr("name");
      var data_id = $(this).attr("id");
      var main_remove_val = data_name.slice(0, -1);
      var fieldIndex = index + 2;
      if (main_len == index_get) {
        $("div#extra-dog-details-jtpl .dog_name")
          .eq(index)
          .attr("name", main_remove_val + "" + fieldIndex + "]");
        $("div#extra-dog-details-jtpl .dog_name")
          .eq(index)
          .attr("id", data_id + "-" + fieldIndex);
      }
    });
  }, 200);
  setTimeout(function () {
    var main_len = $("div#extra-dog-details-jtpl .dog_age").length;
    $("div#extra-dog-details-jtpl .dog_age").each(function (index) {
      var index_get = index + 1;
      var data_name = $(this).attr("name");
      var data_id = $(this).attr("id");
      var main_remove_val = data_name.slice(0, -1);
      var fieldIndex = index + 2;
      if (main_len == index_get) {
        $("div#extra-dog-details-jtpl .dog_age")
          .eq(index)
          .attr("name", main_remove_val + "" + fieldIndex + "]");
        $("div#extra-dog-details-jtpl .dog_age")
          .eq(index)
          .attr("id", data_id + "-" + fieldIndex);
      }
    });
  }, 200);
});
// sign-up end

/* $("#extra-dog").click(function(){
$("#extra-dog-details-jtpl").css("display", "block");
});
$('#extra-dog').on('click',function(){
$('#extra-dog').off('click');
});*/

$(".back-jtpl-Subtitle-1").click(function () {
  window.history.back();
});

var i = 1;
$("#extra-dog").on("click", function () {
  if (i >= 5) {
    $("#extra-dog").off("click");
  }
  i += 1;
});
$(document).on(
  "click",
  ".cart-subscription-box .sls-label-container",
  function () {
    var this1 = $(this);
    $(this)
      .parents(".sls-purchase-options-container")
      .find(".sls-option-container")
      .removeClass("sls-active");

    $(this).parents(".sls-option-container").addClass("sls-active");
    $(this).parents(".mini-cart__item").addClass("active-ed");
    var vID = $(this).parents(".mini-cart__item").attr("data-variant-id");
    var qty = $(this).parents(".mini-cart__item").find(".quantity").val();
    var get_price = $(this)
      .parents(".sls-option-container")
      .find(".sls-price .money")
      .html();
    $(this)
      .parents(".mini-cart__item")
      .find(".mini-cart__item-price .money")
      .html(get_price);
    if ($(this).parents(".sls-option-container").hasClass("once-off")) {
    } else {
      $(this).parents(".cart__item").addClass("active_page");
    }
  }
);



if ($("body").hasClass("cart")) {
  $(document).on(
    "change",
    ".cart-subscription-box select.sls-select.seal-tight.needsclick",
    function () {
      $(this).parents(".cart__item").find(".loader_custom").addClass("active");

      var get_sel_value = $(this).val();
      var get_variant_id = $(this)
        .parents(".cart__item")
        .attr("data-variant-id");
      var get_quantity = $(this)
        .parents(".cart__item")
        .find("input.quantity")
        .val();
      var set_quanity = get_quantity - 1;

      $(this).parents(".cart__item").addClass("active_cart");
      var get_key = $(this).parents(".cart__item").attr("data-line-id");
      var $this = $(this);

      //$(".mini-cart__item.active_cart a.cart__remove-btn").trigger('click');
      data = {
        id: get_variant_id,
        selling_plan: get_sel_value,
        quantity: get_quantity,
      };
      data2 = { line: get_key, quantity: 0 };
      jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data2,
        dataType: "json",
        success: function () {
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              var get_line_no = $this
                .parents(".cart__item")
                .attr("data-line-id");
              $.ajax({
                url: "/",
                type: "GET",
                dataType: "html",
                success: function (data) {
                  window.location.href = "/cart";
                },
              });
            },
          });
        },
      });
    }
  );

  $(document).on(
    "click",
    ".sls-option-container.once-off.seal-table",
    function () {
      $(this).parents(".cart__item").removeClass("active_page");

      $(this).parents(".cart__item").find(".loader_custom").addClass("active");
      $(this).parents(".cart__item").removeClass("active-ed");
      var get_variant_id = $(this)
        .parents(".cart__item")
        .attr("data-variant-id");
      var get_quantity = $(this)
        .parents(".cart__item")
        .find("input.quantity")
        .val();
      var set_quanity = get_quantity - 1;
      $(this).parents(".cart__item").addClass("active_cart");
      var get_key = $(this).parents(".cart__item").attr("data-line-id");

      var $this = $(this);
      //$(".mini-cart__item.active_cart a.cart__remove-btn").trigger('click');
      data = { id: get_variant_id, quantity: get_quantity };
      data2 = { line: get_key, quantity: 0 };

      jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data2,
        dataType: "json",
        success: function () {
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              var get_line_no = $this
                .parents(".cart__item")
                .attr("data-line-id");
              $.ajax({
                url: "/",
                type: "GET",
                dataType: "html",
                success: function (data) {
                  window.location.href = "/cart";
                },
              });
            },
          });
        },
      });
    }
  );
} else {
  $(document).on(
    "change",
    ".cart-subscription-box select.sls-select.seal-tight.needsclick",
    function () {
      $(this).parents("li").find(".loader_custom").addClass("active");

      var get_sel_value = $(this).val();
      var get_variant_id = $(this)
        .parents(".mini-cart__item")
        .attr("data-variant-id");
      var get_quantity = $(this)
        .parents(".mini-cart__item")
        .find("input.quantity")
        .val();
      var set_quanity = get_quantity - 1;

      $(this).parents(".mini-cart__item").addClass("active_cart");
      var get_key = $(this).parents(".mini-cart__item").attr("data-line-id");
      var $this = $(this);

      //$(".mini-cart__item.active_cart a.cart__remove-btn").trigger('click');
      data = {
        id: get_variant_id,
        selling_plan: get_sel_value,
        quantity: get_quantity,
      };
      data2 = { line: get_key, quantity: 0 };
      jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data2,
        dataType: "json",
        success: function () {
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              // var get_line_no =$this.parents('.mini-cart__item').attr('data-line-id');

              $.ajax({
                url: "/",
                type: "GET",
                dataType: "html",
                success: function (data) {
                  $("li.cart_subtotal.js-cart_subtotal .money").html(
                    $(data)
                      .find("li.cart_subtotal.js-cart_subtotal .money")
                      .html()
                  );
                  $("ul.cart_items.js-cart_items").html(
                    $(data).find("ul.cart_items.js-cart_items").html()
                  );
                  $(this)
                    .parents("li")
                    .find(".loader_custom")
                    .removeClass("active");
                  $(".sealsubs-target-element").addClass("active-ed");
                },
              });
            },
          });
        },
      });
    }
  );

  $(document).on(
    "click",
    ".sls-option-container.once-off.seal-table",
    function () {
      $(this).parents("li").find(".loader_custom").addClass("active");
      $(this).parents(".mini-cart__item").removeClass("active-ed");
      var get_variant_id = $(this)
        .parents(".mini-cart__item")
        .attr("data-variant-id");
      var get_quantity = $(this)
        .parents(".mini-cart__item")
        .find("input.quantity")
        .val();
      var set_quanity = get_quantity - 1;
      $(this).parents(".mini-cart__item").addClass("active_cart");
      var get_key = $(this).parents(".mini-cart__item").attr("data-line-id");

      var $this = $(this);
      //$(".mini-cart__item.active_cart a.cart__remove-btn").trigger('click');
      data = { id: get_variant_id, quantity: get_quantity };
      data2 = { line: get_key, quantity: 0 };

      jQuery.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: data2,
        dataType: "json",
        success: function () {
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              // var get_line_no =$this.parents('.mini-cart__item').attr('data-line-id');
              $.ajax({
                url: "/",
                type: "GET",
                dataType: "html",
                success: function (data) {
                  $("li.cart_subtotal.js-cart_subtotal .money").html(
                    $(data)
                      .find("li.cart_subtotal.js-cart_subtotal .money")
                      .html()
                  );
                  $("ul.cart_items.js-cart_items").html(
                    $(data).find("ul.cart_items.js-cart_items").html()
                  );

                  $(
                    ".cart-subscription-box select.sls-select.seal-tight.needsclick .choose-subscription"
                  ).remove();
                  $(
                    ".cart-subscription-box select.sls-select.seal-tight.needsclick"
                  ).prepend(
                    "<option class= 'choose-subscription' value='choose-subscription'>Choose subscription</option>"
                  );
                  $(
                    ".cart-subscription-box select.sls-select.seal-tight.needsclick"
                  )
                    .val("choose-subscription")
                    .prop("selected", true);
                  $(
                    ".cart-subscription-box select.sls-select.seal-tight.needsclick"
                  )
                    .val("choose-subscription")
                    .attr("selected", true);
                  $(this)
                    .parents("li")
                    .find(".loader_custom")
                    .removeClass("active");
                },
              });
            },
          });
        },
      });
    }
  );
}
document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(() => {
    const addToCartBtn = document.querySelector("#hwsubsCheckout");
    const productInfoWrapper = document.querySelector(".Hw-subs-container-box");

    // Run only when both elements exist
    if (addToCartBtn && productInfoWrapper) {
      observer.disconnect(); // stop observing after elements are found

      window.addEventListener("scroll", function () {
        const productInfoRect = productInfoWrapper.getBoundingClientRect();
        // Adjust 70px instead of 50px for your sticky header
        if (productInfoRect.bottom <= 70) {
          addToCartBtn.classList.add("sticky");
        } else {
          addToCartBtn.classList.remove("sticky");
        }
      });
    }
  });

  // Observe DOM changes to detect when elements are added
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

